import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { rootPersistConfig, rootReducer } from './rootReducer';
import {createWebSocketMiddleware} from "../middleware/websocket";

// ----------------------------------------------------------------------

let wsMiddleware = createWebSocketMiddleware();

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  }).concat(wsMiddleware)
});

const persistor = persistStore(store);

export { store, persistor };
